import copyObj from 'fast-copy';

/**
 * Given a List, construct a mapping of that list. This function does not copy since
 * we would the list and the map to refer to the same objects.
 */
export const constructMap = (arr) => {
  let map = {};
  for (let i = 0; i < arr.length; i++) {
    const t = arr[i];

    if (map[t.id()]) {
      console.log('!@# constructMap about to throw error');
      console.log('!@# constructMap i', i);
      console.log('!@# constructMap arr', arr);
      console.log('!@# constructMap map', map);
      throw new Error(`Unable to add item with id:${t.id()}. Item already exists in the map.`);
    }

    map[t.id()] = t;
  }

  return map;
};

export const copyObject = (obj, name, args = {}) => {
  const {
    warnMS = 30,
    errorMS = 1000,
  } = args;

  const start = new Date().valueOf();
  const copy = copyObj(obj);
  const elapsedMS = new Date().valueOf() - start;

  if (elapsedMS > errorMS) {
    console.error(`Unacceptably slow copy (${elapsedMS}ms) for ${name}`);
  } else if (elapsedMS > warnMS) {
    console.warn(`Slow copy (${elapsedMS}ms) for ${name}`);
  }

  return copy;
};

export const isValueEmpty = (value) => {
  if (Array.isArray(value)) {
    return value.length === 0;
  }

  return value === undefined || value === null || value === '';
};

export const findConnection = (current) => {
  let connection = null;
  while (current !== undefined) {
    let connection;
    if (typeof current.connection === 'function') {
      connection = current.connection();

      if (connection) return connection;
    }

    if (typeof current.parent === 'function') {
      current = current.parent();
    } else {
      return connection;
    }
  }

  return connection;
}
